module.exports = function MissingTopicRequest(sessionID, selector) {
    this.sessionID = sessionID;
    this.selector = selector;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/missing-topic/missing-topic-request.js
// module id = 500
// module chunks = 0